// extracted by mini-css-extract-plugin
export default {"scheduler-instance":"ShedulerInstance_scheduler-instance__8Yvpw"};